import React from 'react';
import { BlockSkeleton } from '../common/TableSkeleton';

/**
 * KPI card skeleton — Phase 9.
 *
 * Same shape / min-height as `<KpiCard />` so the layout doesn't jump when
 * data arrives.
 */
export default function KpiCardSkeleton({ testId }) {
    return (
        <div
            data-testid={testId || 'kpi-skeleton'}
            className="bg-white rounded-xl border border-[#E5E7EB] p-4 shadow-[0_1px_2px_rgba(16,24,40,0.05)] flex flex-col gap-3 min-h-[132px]"
        >
            <div className="flex items-start justify-between">
                <BlockSkeleton className="h-3 w-24" />
                <BlockSkeleton className="w-9 h-9 rounded-lg" />
            </div>
            <BlockSkeleton className="h-7 w-24 mt-2" />
            <div className="flex items-center gap-2 mt-auto">
                <BlockSkeleton className="h-3 w-16" />
                <BlockSkeleton className="h-3 w-28" />
            </div>
        </div>
    );
}
